import { Result } from "@cartographerio/fp";
import { isFeatureF, isGeometry, } from "@cartographerio/geometry";
import { hasOptionalKey, isBoolean, isNullable, isObject, isString, } from "@cartographerio/guard";
import { isPartialData } from "../NeRiverNaturalness/parts.js";
export { isPartialData };
function isRiverAreaAttributes(v) {
    return (isObject(v) &&
        hasOptionalKey(v, "ea_wb_id", isNullable(isString)) &&
        hasOptionalKey(v, "headwater", isNullable(isBoolean)));
}
export function isRiverAreaInfo(v) {
    return (isObject(v) &&
        hasOptionalKey(v, "feature", isNullable(isFeatureF(isGeometry, isRiverAreaAttributes))));
}
const g = Result.guard(isPartialData(isRiverAreaInfo), "PartialData");
function createDescription(...args) {
    return args.filter(arg => arg != null).join(" ");
}
export function dataDescription(data) {
    return g(data).map(data => createDescription(data.site.feature?.properties.ea_wb_id ?? "Unknown Waterbody", data.site.feature?.properties.headwater ? "(Headwater)" : "(Larger River)"));
}
export function dataGeometry(data) {
    return g(data).map(data => data.site?.feature?.geometry ?? null);
}
export function dataTimestamp(data) {
    return g(data).map(data => data.recorded ?? null);
}
export function copyData(data) {
    return g(data).map(data => ({
        ...data,
        // recorded: null,
        // site: {},
        // selections: {
        //   physical: null,
        //   physicalMeasures: [],
        //   otherPhysicalMeasures: null,
        //   hydrological: null,
        //   hydrologicalMeasures: [],
        //   otherHydrologicalMeasures: null,
        //   chemical: null,
        //   chemicalMeasures: [],
        //   otherChemicalMeasures: null,
        //   biological: null,
        //   biologicalMeasures: [],
        //   otherBiologicalMeasures: null,
        // },
        // notes: null,
    }));
}
//# sourceMappingURL=parts.js.map